import store from '@/store';
import Vue from 'vue';
import Router from 'vue-router';
import auth from '../utils/auth';
import i18n from '../i18n';
import { isAgoWidgetExisting, initAgoWidget, hideAgoWidget, showAgoWidget } from '../plugins/ago';


Vue.use(Router);

const routes = [
  {
    path: '*',
    redirect: i18n.locale === 'fr' ? { name: 'HomePage' } : i18n.locale,
  },
  {
    path: '/:locale(^[en]$)?',
    name: 'HomePage',
    component: () => import('@/pages/homepage'),
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/pages/login'),
    children: [
      {
        path: 'reset-password',
        name: 'ResetPassword',
        meta: {
          showModal: true,
        },
      },
    ],
  },
  {
    path: '/fc-callback',
    name: 'LoginFranceConnectCallback',
    component: () => import('@/pages/login'),
    props: {
      isFcCallback: true,
    },
  },
  {
    path: '/fc-callback-activation',
    name: 'ActivationFranceConnectCallback',
    component: () => import('@/pages/activate'),
    props: {
      isFcCallback: true,
    },
  },
  {
    path: '/gpartage',
    name: 'login.guest',
    component: () => import('@/pages/login'),
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('@/pages/login'),
  },
  {
    path: '/maintenance',
    name: 'Maintenance',
    component: () => import('@/pages/maintenance'),
  },
  {
    path: '/password-initialization/:token',
    name: 'reset.password',
    props: true,
    component: () => import('@/pages/resetPassword'),
  },
  {
    path: '/activate',
    name: 'Activate',
    component: () => import('@/pages/activate'),
  },
  {
    path: '/activate/:sessionId/:encodedUserDatas',
    name: 'Activate',
    props: true,
    component: () => import('@/pages/activate'),
  },
  {
    path: '/security',
    name: 'Security',
    component: () => import('@/pages/security'),
  },
  {
    path: '/prices',
    name: 'Prices',
    component: () => import('@/pages/tarif'),
  },
];

// to improve SEO, we add "en" in urls if english locale to distinguish the two languages version of the website: french and english

if (i18n.locale === 'en') {
  for (let i = 0; i !== routes.length; i += 1) {
    if (routes[i].path !== '*') {
      routes[i].path = `/${i18n.locale}${routes[i].path}`;
    }
  }
}

const router = new Router({
  mode: 'history',
  base: `${process.env.BASE_URL ? process.env.BASE_URL : ''}/`,
  routes,
});

function getMIPIH() {
  return auth.getConf().then(response => response.CONF.MIPIH);
}

function computeHrefLangLink(to) {
  document.head.querySelector('#fr_link').href = i18n.locale !== 'fr' ?
    `${window.location.origin}${to.fullPath.slice(3, to.fullPath.length)}` :
    `${window.location.origin}${to.fullPath}`;
  document.head.querySelector('#en_link').href = i18n.locale === 'fr' ?
    `${window.location.origin}/en${to.fullPath}` :
    `${window.location.origin}${to.fullPath}`;
}

router.beforeEach(async (to, from, next) => {
  // we compute the good link for hreflang, depending on the actual locale
  computeHrefLangLink(to);
  // we compute the good english url on url direct access
  if (i18n.locale === 'en' && to.redirectedFrom) {
    if (to.redirectedFrom.slice(0, 3) !== '/en') {
      next(`/en${to.redirectedFrom}`);
    }
  }
  if (await getMIPIH()) {
    store.dispatch('authentification/setMIPIH', true);
    if (to.path === '/') next('/login');
    else next();
  } else next();

  if (to.name !== 'HomePage') {
    if (isAgoWidgetExisting()) {
      showAgoWidget();
    } else {
      initAgoWidget();
    }
  } else if (isAgoWidgetExisting()) hideAgoWidget();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js